import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "category-content p-5" }
const _hoisted_2 = { class: "category-button-container" }
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = ["data-bs-target"]
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = {
  key: 0,
  class: "childCategories-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_InnerCategoryComponent = _resolveComponent("InnerCategoryComponent", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["category", {
      open: _ctx.getOpenCollapse,
      searching: _ctx.getInlineSearch && _ctx.getSearchTerm && _ctx.getSearchTerm.length >= 3,
      inSearch:
        _ctx.getInlineSearch &&
        _ctx.getSearchTerm &&
        _ctx.getSearchTerm.length >= 3 &&
        _ctx.category.name.toUpperCase().includes(_ctx.getSearchTerm.toUpperCase()),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.category.name) + " ", 1),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.category.childCategories && _ctx.category.childCategories.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCollapse())),
              class: _normalizeClass(["btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 collapse-btn", { 'vertical-rotate': _ctx.getOpenCollapse }])
            }, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_inline_svg, { src: "\n              /media/icons/duotune/arrows/arr072.svg\n            " })
              ])
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          "data-bs-toggle": "modal",
          "data-bs-target": '#kt_modal_new_card_' + _ctx.Names.CATEGORIES,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal(_ctx.category.id))),
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "\n              /media/icons/duotune/art/art005.svg\n            " })
          ])
        ], 8, _hoisted_4),
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
            _ctx.deleteItem(
              _ctx.category.id,
              _ctx.index,
              _ctx.category.childCategories && _ctx.category.childCategories.length > 0
                ? true
                : false
            )
          ), ["prevent"])),
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
          ])
        ])
      ])
    ]),
    (_ctx.category.childCategories && _ctx.category.childCategories.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.childCategories, (childCategory) => {
            return (_openBlock(), _createBlock(_component_InnerCategoryComponent, {
              key: childCategory.id,
              category: childCategory
            }, null, 8, ["category"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}